import { useCallback, useMemo } from "react";
import { useSelector } from "react-redux";
import { selectUser } from "reducers";
import { PersonnelResource } from "types/personnel.type";
import { isClient, isPersonnel } from "utils/user.helpers";

export const useUser = () => {
  const user = useSelector(selectUser);

  if (!user) {
    throw new Error("Pas d'utilisateur");
  }

  const requestParams = useMemo(() => {
    const params: Record<string, any> = {};
    if (isClient(user)) {
      params.clientId = user.userableId;
    }
    return params;
  }, [user]);

  const getUserCentre = useCallback(() => {
    if (isPersonnel(user) && user.userable) {
      return (user.userable as PersonnelResource).centre;
    }
    return undefined;
  }, [user]);

  const canWrite = useCallback(
    (key: string) => {
      return user.modules ? user.modules[key]?.canWrite : false;
    },
    [user.modules],
  );

  const canRead = useCallback(
    (key: string) => {
      return user.modules ? user.modules[key]?.canRead : false;
    },
    [user.modules],
  );

  const canReadOrWrite = useCallback(
    (key: string) => {
      return canRead(key) || canWrite(key);
    },
    [canRead, canWrite],
  );

  return {
    paysId: user.pays?.id,
    user,
    requestParams,
    canWrite,
    canRead,
    canReadOrWrite,
    getUserCentre,
  };
};
